import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface DesktopProps {
  children: ReactNode;
}

export const Desktop = ({ children }: DesktopProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return isDesktop ? <>{children}</> : null;
};
